export function buildMediaGridVideoKey(videoUrl, answerId = null) {
    if (!videoUrl) return null

    const source = String(videoUrl)
    const ownerId = answerId == null ? '' : String(answerId)
    return ownerId ? `media-grid-video:${ownerId}:${source}` : `media-grid-video:${source}`
}
